import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* <ul className="breadcrumb">
        <li>
          <Link to="/">
            <i className="fa fa-home" />
          </Link>
        </li>
        <li>
          <Link to="/about-us"> / About Sundial</Link>
        </li>
      </ul> */}

      <main className="about-main">
        <div className="about-main-heading">
          <h3>About Sundial</h3>
        </div>
        <div className="about-navs">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="about-nav-links">
                  <ul className="about-nav-links-list">
                    <Link to="/about-us">About Sundial</Link>
                    <a href="#who-we-are" className="nav-links">
                      Who We Are Sundial
                    </a>
                    <a href="#our-faimly" className="nav-links">
                      Our promise / Our belief
                    </a>
                    <a href="#our-promise" className="nav-links">
                      What we stand for
                    </a>
                    <a href="#company-culture" className="nav-links">
                      Where are we located
                    </a>
                    <a href="#our-beginnings" className="nav-links">
                      Our beginnings
                    </a>
                  </ul>
                </div>
              </div>
              <div className="col-md-9">
                <div className="about-nav-pils">
                  <div id="who-we-are">
                    <div className="who-header">
                      <h4 className="sec-heading">Who We Are</h4>
                      <p>
                        Sundial is a premier online destination for all things
                        home. Our team consist of a small group of dedicated
                        individuals who have a passion for making our customers’
                        homes extraordinary. We aim to provide our customer with
                        a fun and convenient online shopping experience.
                      </p>
                    </div>
                    {/* 
                      
                      
                      
                      */}
                  </div>
                  <div id="our-faimly">
                    <div className="faimly-header">
                      <h4 className="sec-heading">Our promise / Our belief</h4>
                      <p>
                        At Sundial, we believe your home should be your
                        sanctuary. The Sundial team attends the biggest trade
                        shows every year, curating a selection of the most
                        amazing products for our valuable customers. Through
                        technology and innovation, we make it possible for
                        online shoppers to access a huge assortment of products
                        including home furnishings, décor, home improvement,
                        houseware, and much more. Sundial is committed to
                        exceeding its customers’ expectations every step of the
                        way - from product discovery to final delivery.
                      </p>
                    </div>
                    <div className="brands-section">
                      <div className="row">
                        <div className="col-md-4 col-sm-6 col-12 m-md-0 m-sm-4 my-4">
                          <div id="overlay-content">
                            <div className="faimly-img">
                              <img
                                src="https://sundialinsider.s3.us-east-2.amazonaws.com/385sidebar-slider-img.jpg"
                                alt=""
                                width="100%"
                              />
                            </div>
                            <div className="faimly-img-overlay">
                              <div className="overlay-on-hover">
                                <span>Sundial</span>
                                <div className="f-overlay-txt">
                                  <span>
                                    The Best Modern design you ever seen
                                  </span>
                                  <a href="#">Visit Site</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-6 col-12 m-md-0 m-sm-4 my-4">
                          <div id="overlay-content">
                            <div className="faimly-img">
                              <img
                                src="https://sundialinsider.s3.us-east-2.amazonaws.com/385sidebar-slider-img.jpg"
                                alt=""
                                width="100%"
                              />
                            </div>
                            <div className="faimly-img-overlay">
                              <div className="overlay-on-hover">
                                <span>Sundial</span>
                                <div className="f-overlay-txt">
                                  <span>
                                    The Best Modern design you ever seen
                                  </span>
                                  <a href="#">Visit Site</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-6 col-12 m-md-0 m-sm-4 my-4">
                          <div id="overlay-content">
                            <div className="faimly-img">
                              <img
                                src="https://sundialinsider.s3.us-east-2.amazonaws.com/385sidebar-slider-img.jpg"
                                alt=""
                                width="100%"
                              />
                            </div>
                            <div className="faimly-img-overlay">
                              <div className="overlay-on-hover">
                                <span>Sundial</span>
                                <div className="f-overlay-txt">
                                  <span>
                                    The Best Modern design you ever seen
                                  </span>
                                  <a href="#">Visit Site</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row my-5">
                        <div className="col-md-4 col-sm-6 col-12 m-md-0 m-sm-4 my-4">
                          <div id="overlay-content">
                            <div className="faimly-img">
                              <img
                                src="https://sundialinsider.s3.us-east-2.amazonaws.com/385sidebar-slider-img.jpg"
                                alt=""
                                width="100%"
                              />
                            </div>
                            <div className="faimly-img-overlay">
                              <div className="overlay-on-hover">
                                <span>Sundial</span>
                                <div className="f-overlay-txt">
                                  <span>
                                    The Best Modern design you ever seen
                                  </span>
                                  <a href="#">Visit Site</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-6 col-12 m-md-0 m-sm-4 my-4 ">
                          <div id="overlay-content">
                            <div className="faimly-img">
                              <img
                                src="https://sundialinsider.s3.us-east-2.amazonaws.com/385sidebar-slider-img.jpg"
                                alt=""
                                width="100%"
                              />
                            </div>
                            <div className="faimly-img-overlay">
                              <div className="overlay-on-hover">
                                <span>Sundial</span>
                                <div className="f-overlay-txt">
                                  <span>
                                    The Best Modern design you ever seen
                                  </span>
                                  <a href="#">Visit Site</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-6 col-12 m-md-0 m-sm-4 my-4">
                          <div id="overlay-content">
                            <div className="faimly-img">
                              <img
                                src="https://sundialinsider.s3.us-east-2.amazonaws.com/385sidebar-slider-img.jpg"
                                alt=""
                                width="100%"
                              />
                            </div>
                            <div className="faimly-img-overlay">
                              <div className="overlay-on-hover">
                                <span>Sundial</span>
                                <div className="f-overlay-txt">
                                  <span>
                                    The Best Modern design you ever seen
                                  </span>
                                  <a href="#">Visit Site</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="our-promise">
                    <div className="promise-header">
                      <h4 className="sec-heading">What we stand for</h4>
                      <div className="promise-section">
                        <p>
                          With big aspirations, come big responsibilities. At
                          Sundial, we are dedicated to giving back. By donating
                          our time to keep earth beautiful, and donating money
                          to charities that help our community, we promise to
                          help better the world that we live in.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div id="company-culture">
                    <div className="culture-header">
                      <h4 className="sec-heading">Where are we located</h4>
                      <div className="culture-section">
                        <p>
                          Sundial headquarters are located in the Bay Area,
                          California, but we serve the entire United States.
                        </p>

                        <div className="culture-products">
                          <img
                            src="https://sundialinsider.s3.us-east-2.amazonaws.com/385sidebar-slider-img.jpg"
                            alt=""
                            width="100%"
                          />
                          <div className="culture-img-name">
                            <p>Boston Business Journal</p>
                            <p>Best Places To Work</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="our-beginnings">
                    <div className="promise-header">
                      <h4 className="sec-heading">Our beginnings</h4>
                      <div className="promise-section">
                        <p>
                          In 2005, we began as a mom and pop home remodeling
                          operation. After 15 years of helping Bay Area
                          residents revamp their homes, we decided to expand our
                          operations nationwide. In 2019, Sundial was formed!
                          Now that we are able to reach a far larger audience,
                          we aim to provide the same quality service in an
                          online environment to the entire United States.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/*COL-MD-9*/}
            </div>
            {/*ROW*/}
          </div>
          {/*CONTAINER-FLUID*/}
        </div>
        {/*ABOUT NAVS*/}
      </main>
    </>
  );
};

export default AboutUs;
